import React, { useEffect, useState } from "react";
import {
    IonModal,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonLabel,
    IonInput,
    IonContent,
    IonIcon,
    IonItem,
    IonList,
    IonSkeletonText,
    IonSpinner,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardContent,
} from "@ionic/react";
import { chatbubbleEllipsesOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";
import { Answer } from "frontend-lib/DomainTypes/KnowledgeRecord";
import { Empty } from "antd";
import {
    documentTextOutline,
    documentOutline,
    playOutline,
    musicalNoteOutline,
    imageOutline,
} from "ionicons/icons";

type Props = {
    isVisible: boolean;
    closePredictModal: () => void;
    currentText: string;
    onSearchKnowledge: (value: string) => void;
    recommendations?: Array<Answer>;
    recoLoading: boolean;
    setSelectedAnswer: (r: Answer) => void;
    setRecommendationModalVisible: () => void;
};

export default function PredictModalMobile(props: Props) {
    const { t } = useTranslation();
    const [question, setQuestion] = useState<string>(props.currentText);

    useEffect(() => {
        if (props.isVisible) setQuestion(props.currentText);
    }, [props.isVisible, props.currentText]);

    const renderRecommendations = () => {
        if (!props.recommendations?.length) {
            return <Empty />;
        }

        return props.recommendations?.map((r) => (
            <IonCard
                button
                onClick={() => {
                    props.setSelectedAnswer(r);
                    props.setRecommendationModalVisible();
                }}
            >
                <IonCardHeader>
                    <IonCardSubtitle>
                        {r.knowledgeRecord.title}
                        {renderAttachmentIcons(r)}
                    </IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                    <div
                        style={{
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {r.answer}
                    </div>
                </IonCardContent>
            </IonCard>
        ));
    };

    const renderAttachmentIcons = (answer: Answer) => {
        const attachmentsIcons = answer.attachments.map((a) => {
            switch (a.attachmentType) {
                case "AUDIO":
                    return <IonIcon icon={musicalNoteOutline} />;
                case "DOCUMENT":
                    return <IonIcon icon={documentTextOutline} />;
                case "VIDEO":
                    return <IonIcon icon={playOutline} />;
                case "IMAGE":
                    return <IonIcon icon={imageOutline} />;
                default:
                    return <IonIcon icon={documentOutline} />;
            }
        });
        return <>{attachmentsIcons}</>;
    };

    return (
        <IonModal isOpen={props.isVisible}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>{t("predictModalTitle")}</IonTitle>
                    <IonButtons slot="start">
                        <IonButton onClick={() => props.closePredictModal()}>
                            {t("close")}
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <IonItem>
                    <IonIcon
                        icon={chatbubbleEllipsesOutline}
                        slot="start"
                        style={{ fontSize: "3rem" }}
                    />
                    <IonLabel position="stacked" color="medium">
                        {t("question")}
                    </IonLabel>
                    <IonInput
                        value={question}
                        clearInput
                        onIonChange={(e) => setQuestion(e.detail.value || "")}
                    />
                </IonItem>

                <IonButton
                    disabled={!Boolean(question) || props.recoLoading}
                    expand="block"
                    onClick={() => props.onSearchKnowledge(question)}
                >
                    {props.recoLoading && <IonSpinner name="circular"></IonSpinner>}
                    {t("filters.search")}
                </IonButton>

                {props.recoLoading ? (
                    <IonList>
                        {Array.from(Array(5).keys()).map((_) => (
                            <IonItem>
                                <IonLabel>
                                    <IonSkeletonText animated />
                                    <IonSkeletonText animated style={{ width: "80%" }} />
                                </IonLabel>
                            </IonItem>
                        ))}
                    </IonList>
                ) : (
                    renderRecommendations()
                )}
            </IonContent>
        </IonModal>
    );
}
